import { render, staticRenderFns } from "./onebox-myfiles-scrolling-new.vue?vue&type=template&id=c897a61c&scoped=true&"
import script from "./onebox-myfiles-scrolling-new.vue?vue&type=script&lang=js&"
export * from "./onebox-myfiles-scrolling-new.vue?vue&type=script&lang=js&"
import style0 from "./onebox-myfiles-scrolling-new.vue?vue&type=style&index=0&id=c897a61c&scoped=true&lang=css&"
import style1 from "./onebox-myfiles-scrolling-new.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c897a61c",
  null
  
)

export default component.exports